import { Link } from 'react-router';
import { OctoMark } from '@/shared/ui/OctoMark';
import { useAppInfo } from '../api/shellInfoApi';

/**
 * Başlıktaki marka kilidi: logomark + ürün adı + bağlı olunan firma.
 *
 * Firma adı web'deki gibi OCTO'nun SAĞINDA, ince bir ayraçla duruyor (önce alt satırda
 * çiziliyordu ve zaten hiçbir yerden beslenmiyordu). Hangi firmada olunduğu üst çubukta
 * görünmeli: paylaşımlı kurulumda aynı adresten birden fazla firmaya giriliyor ve yanlış
 * firmada veri girmek pahalı bir hata.
 *
 * Uzun ünvan arama kutusunu ve kur alanını kırpmasın diye kısaltılıyor — ama her ekran
 * genişliğinde GÖRÜNÜR: önce yalnız geniş ekranda çiziliyordu ve dar pencerede çalışan
 * kullanıcı hangi firmada olduğunu göremiyordu.
 */
export function BrandLogo({ companyName }: { companyName?: string | null }) {
  const appInfo = useAppInfo();
  /*
   * Firma adının yanına aboneliğin AÇIKLAMASI ekleniyor.
   *
   * Aynı müşteriye aynı üründen birden fazla abonelik tanımlanabiliyor ("Üretim" /
   * "Test" gibi) ve bunlar yalnızca açıklamayla ayrılıyor; yalnızca firma adı
   * gösterildiğinde iki kurulum üst çubukta birbirinin aynısı görünüyordu.
   * Açıklama yoksa eskisi gibi tek başına ad çıkar.
   */
  const description = appInfo.data?.description?.trim() || null;
  const name = companyName ?? appInfo.data?.customerName ?? null;
  const company = name && description ? `${name} · ${description}` : (name ?? description);

  return (
    <Link
      to="/"
      className="focus-visible:ring-ring flex items-center gap-2 rounded-md focus-visible:ring-2 focus-visible:outline-none"
    >
      <OctoMark className="h-8 w-8 shrink-0" />
      <span className="text-sm font-bold tracking-wide">OCTO</span>
      {company ? (
        <span
          title={company}
          className="border-border/60 text-fg-muted ml-1 max-w-[7rem] truncate border-l pl-2 text-[13px] font-semibold sm:max-w-[12rem] lg:max-w-[16rem] xl:max-w-[20rem]"
        >
          {company}
        </span>
      ) : null}
    </Link>
  );
}
